import { Avatar, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ProjectDataItem(props) {
    const { project } = props;
    const navigate = useNavigate();
    const handleOnClickViewProject = () => navigate(`/projects/${project?.id}`, { state: { project } });

    const Status = [
        project?.lifecycle_status?.name_display,
        project?.is_flagship ? "Flagship" : "Normal",
        project?.achievement_status?.name_display,
    ].join(" | ");

    return (
        <Box sx={{ display: "flex", marginY: 2 }}>
            {/** Header */}
            <Box onClick={handleOnClickViewProject} sx={{ marginRight: 2, "&:hover": { cursor: "pointer" } }}>
                <Avatar variant="rounded" color="secondary" sizes="54" sx={{ width: 54, height: 54 }}>
                    #{project?.id}
                </Avatar>
            </Box>

            <Box sx={{ flexGrow: 1, marginRight: 1 }}>
                <Box
                    onClick={handleOnClickViewProject}
                    sx={{
                        fontWeight: "bold",
                        "&:hover": {
                            textDecoration: "underline",
                            cursor: "pointer",
                        },
                    }}
                >
                    {project?.name}
                </Box>
                <Box>{project?.name_en}</Box>
                <Box sx={{ color: "gray" }}>{Status}</Box>
            </Box>

            <Box sx={{ flexShrink: 0, color: "gray" }}>
                <Box>Updated</Box>
                <Box>{project?.updated_at ? new Date(project?.updated_at).toLocaleDateString() : "-/-/-"}</Box>
            </Box>
        </Box>
    );
}

export default ProjectDataItem;
